<template>
  <div>
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top:24px">
        <el-breadcrumb-item :to="{ path: '/customerBalance' }" style="font-size:24px">自录客户结算</el-breadcrumb-item>
        <el-breadcrumb-item style="font-size:24px">开票明细</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" type="primary" plain @click="exportList" style="margin-top: 20px">导出</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableList" stripe border style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="编码" prop="INNER_CODE"></el-table-column>
          <el-table-column label="名称" prop="NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="价格" prop="PRICE"></el-table-column>
          <el-table-column label="订单数量" prop="TOTAL_COUNT"></el-table-column>
          <el-table-column label="总金额" prop="TOTAL_WORTH"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryTCInvoiceFun, exportTCInvoiceFun } from 'api/tcBanlance';

export default {
  data() {
    return {
      tableList: [],
    };
  },
  created() {
    this.queryList();
  },
  methods: {
    queryList() {
      const params = {
        TC_ID: Number(sessionStorage.getItem('TC_ID')),
        MONTH: sessionStorage.getItem('MONTH'),
      };
      queryTCInvoiceFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableList = result;
        } else {
          this.tableList = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ tetx: error, type: 'error' });
      });
    },
    exportList() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            TC_ID: Number(sessionStorage.getItem('TC_ID')),
            MONTH: sessionStorage.getItem('MONTH'),
          };
          exportTCInvoiceFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/balanceManage/invoiceDetail.vue